import BasicDetails from '../../../../Negotiation Process/BasicDetails';
import { FormikProps } from 'formik';
import TargetValue from '../../../../Negotiation Process/TargetValue';
import PowerPositionComponent from '../../../../Negotiation Process/Power Position/powerPosition';
import SalesRepClassification from '../../../../Negotiation Process/Sales Rep Classification/salesRepClassification';

interface Props {
    formName: string;
    formikRef: React.RefObject<FormikProps<any> | null>;
    setIsNextDisabled: React.Dispatch<React.SetStateAction<boolean>>
}
const NegotiationFormComponent = ({ formName, formikRef, setIsNextDisabled }: Props) => {

    return (
        <div className="negotiation-overview-container">
            {formName === "Basic Details" && <BasicDetails setIsNextDisabled={setIsNextDisabled} setRefInstance={(instance: FormikProps<any> | null) => (formikRef.current = instance)} />}
            {formName === "Power Position" && <PowerPositionComponent currentStep={0} totalSteps={0} goNext={() => { }} goBack={() => { }} isNextDisabled={false} isDetailedOverview={true} />}
            {formName == "Sales Rep Classification" && <SalesRepClassification currentStep={0} totalSteps={0} goNext={() => { }} goBack={() => { }} isNextDisabled={false} isDetailedOverview={true} />}
            {formName == "Target Value" && <TargetValue setIsNextDisabled={setIsNextDisabled} setRefInstance={(instance: FormikProps<any> | null) => (formikRef.current = instance)} isDetailedOverview={true} />}
        </div>
    )
}

export default NegotiationFormComponent;